<template>
  <div class="itemInfo-box">
    <template v-if="dialogData.isAdd=='1'">
      <div class="add-catalog" @click="addCatalog">
        <i class="el-icon-plus icon-add"></i>
        <p>添加编目</p>
      </div>
    </template>
    <template v-else>
      <div class="flex-form">
        <el-form :label-position="'left'" :model="form" label-width="90px">
          <el-tooltip :disabled="dialogData.name == null ||  dialogData.name.length < 10" class="item" effect="dark" :content="dialogData.name" placement="top">
            <el-form-item label="标题："><span class="tool-tips">{{dialogData.name}}</span></el-form-item>
          </el-tooltip>
          <el-tooltip :disabled="dialogData.nameInitials == null || dialogData.nameInitials.length < 10" class="item" effect="dark" :content="dialogData.nameInitials" placement="top">
            <el-form-item label="标题字母："><span class="tool-tips">{{dialogData.nameInitials}}</span></el-form-item>
          </el-tooltip>
          <el-form-item label="二级分类：">{{dialogData.sndCategory}}</el-form-item>
          <el-form-item label="关键词：" class="label-key">
            <span v-for="item in keywords" :key="item" class="keywords">{{item}}</span>
          </el-form-item>
        </el-form>
        <el-form :label-position="'left'" :model="form" label-width="90px">
          <el-tooltip :disabled="dialogData.subName == null || dialogData.subName.length < 10"  class="item" effect="dark" :content="dialogData.subName" placement="top">
            <el-form-item label="副标题："><span class="tool-tips">{{dialogData.subName}}</span></el-form-item>
          </el-tooltip>

          <el-form-item label="一级分类：">{{dialogData.category}}</el-form-item>
        </el-form>
        <el-divider></el-divider>
        <el-form :label-position="'left'" :model="form" label-width="90px">
          <el-form-item label="评分：" class="label-key">
            <el-rate v-model="score" disabled show-score text-color="#606266" score-template="{value}星" style="margin-top:5px">
            </el-rate>
          </el-form-item>
          <el-form-item label="清晰度：">{{ dialogData.video && dialogData.video.definition}}</el-form-item>
        </el-form>
        <!-- <el-form :label-position="'left'" :model="form" label-width="90px">
          <el-form-item label="影片的等级:">{{dialogData.movieLevel}}</el-form-item>
        </el-form> -->
      </div>
      <p class="tip">简介</p>
      <div class="introduction" >{{dialogData.dsc}}</div>
      <div class="flex-form">
        <el-form :label-position="'left'" :model="form" label-width="90px">
          <el-form-item label="年份：">{{dialogData.year}}</el-form-item>
        </el-form>
        <el-form :label-position="'left'" :model="form" label-width="90px">
          <el-form-item label="国家地区:">{{dialogData.area}}</el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <div class="demo-form-inline">
        <template v-for="(item,index) in catalogData">
          <el-tooltip v-if="typeof item.value == 'string'" :disabled="item.value == null || item.value.length < 6" :key="index" class="item" effect="dark" :content="item.value" placement="top">
            <p class="form-inline">{{item.itemName}}<span>{{item.value}}</span></p>
          </el-tooltip>
          <p class="form-inline" v-else :key="index">{{item.itemName}}{{item.value}}</p>
        </template>
      </div>
      <!--<el-form :inline="true" :label-position="'left'" :model="form" label-width="110px" class="demo-form-inline">
        <template v-for="(item,index) in catalogData">
          <el-tooltip v-if="typeof item.value == 'string'" :disabled="item.value.length < 6" :key="index" class="item" effect="dark" :content="item.value" placement="top">
            <el-form-item :label="item.itemName"><span class="tool-tips">{{item.value}}</span></el-form-item>
          </el-tooltip>
          <el-form-item v-else :key="index" :label="item.itemName">{{item.value}}</el-form-item>
        </template>
      </el-form>-->
    </template>
  </div>
</template>
<script>
import { fetchCatalogItems } from '@/resource/api/index'
import { getCheckArr } from '@/utils'
export default {
  name: 'TabItemInfo',
  props: ['dialogData', 'project'],
  data () {
    return {
      form: {},
      keywords: this.dialogData.keywords && this.dialogData.keywords.split(' '),
      catalogData: [],
      score: this.dialogData.score ? this.dialogData.score : 0
    }
  },
  watch: {
    dialogData (value) {
      return this.fetchCatalogItems()
    }
  },
  mounted () {
    this.fetchCatalogItems()
  },
  methods: {
    fetchCatalogItems () {
      const fixedAttr = ['name', 'nameInitials', 'sndCategory', 'keywords', 'subName', 'category', 'score', 'definition', 'movieLevel', 'dsc', 'year', 'area']
      const data = {
        category: this.dialogData.category,
        type: 'program',
        platform: process.env.VUE_APP_NODE_ENV
      }
      fetchCatalogItems(data).then((res) => {
        if (res.code == '1') {
          this.catalogData = []
          if (res.result.length > 0) {
            res.result[0].sndCategory.forEach(item => {
              if (fixedAttr.indexOf(item.itemEnName) == -1) {
                this.catalogData.push(item)
              }
            })
            this.catalogData.forEach(item => {
              for (const i in item) {
                if (i == 'itemEnName') {
                  var valEnName = item[i]
                  item.value = this.dialogData[valEnName]
                  item.itemName = item.itemName + '：'
                } else if (i == 'itemCheck') {
                  const itemVal = item[i]
                  const itemCheck = getCheckArr(itemVal)
                  if (itemCheck instanceof Array) {
                    item.itemCheck = itemCheck
                    itemCheck.forEach(checkItem => {
                      if (checkItem.key == this.dialogData[valEnName]) {
                        item.value = checkItem.value
                      }
                    })
                  } else {
                    item.itemCheck = itemCheck.message
                  }
                }
              }
            })
          }
        }
      })
    },
    addCatalog () {
      // isAdd 用于判断介质节目信息是否填写完整 1.需要 0.不需要
      this.$router.push({
        path: '/newGroup',
        query: {
          dialogData: JSON.stringify({
            title: '新增编目',
            orVideoId: this.dialogData.orVideoId,
            programId: this.dialogData.id
          })
        }
      })
    }
  }
}
</script>
<style lang="less">
  .flex-form .el-form-item__label {
    font-size: 14px;
    font-weight: 400;
    color: #666978;
  }
  .demo-form-inline{
    /*display: flex;
    justify-content: space-between;
    flex-wrap: wrap;*/
    .form-inline {
      font-size: 14px;
      padding: 0 5px;
      overflow: hidden;
      width: 50%;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 1.2;
      box-sizing: border-box;
      display: inline-block;
      margin: 0 0 13px;
    }
    .el-form-item {
      float: left;
      width: 45%;
      display: flex;
    }
    .el-form-item__content {
      display: inline-block;
      width: 60%;
    }
  }
</style>
<style scoped lang="less">
  .add-catalog {
    width: 100px;
    height: 80px;
    margin: 80px auto 0;
    border: dashed 1px #D9D9D9;
    background: #FAFAFA;
    text-align: center;
    color: #BBBBBB;
    cursor: pointer;
    .icon-add {
      padding-top: 15px;
      font-weight: bold;
    }
  }
  .flex-form {
    display: flex;
    justify-content:space-between;
    flex-wrap: wrap;
    margin-left: 10px;
    font-size: 13px;
    .el-form {
      width: 55%;
      word-wrap:break-word;
    }
    .el-form:nth-child(2){
      width: 45%;
      word-wrap:break-word;
    }
    .label-key {
      white-space: nowrap;
    }
    .keywords{
      font-weight: 400;
      color: #595959;
      font-size: 12px;
      white-space: nowrap;
      border-radius: 2px;
      border: 1px solid #CFD1D8;
      padding: 1px 4px;
      margin: 0 3px;
    }
  }
  .tip {
    padding-left:10px ;
  }
  .introduction {
    padding: 10px 10px;
    margin-bottom: 15px;
    text-indent: 20px;
    font-size: 14px;
    font-weight: 300;
    color: #33343B;
    background: #F7F8FA;
    border-radius: 4px;
    line-height: 1.5;
    word-wrap:break-word;
  }
  .tool-tips {
    overflow: hidden;
    width: 100%;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1;
  }
</style>
